{
  "name": "wbtvd",
  "version": "15.8.0",
  "description": "Brainiac WBTVD site",
  "license": "UNLICENSED",
  "author": "WBTVD",
  "homepage": "https://github.com/wbdt-sie/wbtvd-web",
  "repository": {
    "type": "git",
    "url": "https://github.com/wbdt-sie/wbtvd-web.git"
  },
  "bugs": {
    "url": "https://wbddigital.atlassian.net/jira/software/c/projects/STUDIO/boards/6/backlog"
  },
  "scripts": {
    "clearcache": "rimraf ~/.local/share/pnpm/store/v3 .parcel-cache/ node_modules/ dist/",
    "dist": "./dist.sh",
    "start": "./scripts/start.sh",
    "start:windows": "node node_modules/parcel/lib/bin.js src/index.html src/lascreenings/index.html src/bafta-video-player/index.html -p 9001 --https --log-level verbose --no-hmr",
    "test": "TZ=UTC jest --maxWorkers=50%",
    "test:ci": "./tests/test.sh",
    "test:ci_file": "./tests/test_ci_file.sh",
    "test:fast": "./tests/test_no_coverage.sh",
    "test:ts": "jest -c ./jest.ts.config.js src/ts",
    "test:watch": "jest --watch"
  },
  "dependencies": {
    "@babel/runtime": "7.23.2",
    "@datadog/browser-rum": "4.42.2",
    "@reduxjs/toolkit": "1.7.1",
    "@wbdt-sie/brainiac-web-common": "1.4.1",
    "bitmovin-player": "8.144.0",
    "bitmovin-player-ui": "3.52.2",
    "bluebird": "3.7.2",
    "bootstrap": "3.4.1",
    "bootstrap4": "npm:bootstrap@4.6.0",
    "btoa": "1.2.1",
    "classnames": "2.3.2",
    "datatables.net": "1.13.8",
    "datatables.net-bs": "1.13.8",
    "datatables.net-responsive": "2.5.0",
    "datatables.net-responsive-bs": "2.5.0",
    "datatables.net-rowreorder": "1.4.1",
    "datatables.net-rowreorder-bs": "1.4.1",
    "detect-browser": "5.3.0",
    "flux": "4.0.4",
    "immutable": "3.8.4",
    "jquery": "3.7.1",
    "jquery-touchswipe": "1.6.19",
    "moment": "2.29.4",
    "moment-timezone": "0.5.43",
    "photoswipe": "4.1.3",
    "prop-types": "15.8.1",
    "query-string": "7.0.1",
    "querystring-es3": "0.2.1",
    "react": "17.0.2",
    "react-autocomplete": "1.8.1",
    "react-bootstrap": "0.33.1",
    "react-datepicker": "4.24.0",
    "react-dom": "17.0.2",
    "react-intl": "5.18.3",
    "react-overlays": "1.2.0",
    "react-pdf": "6.2.2",
    "react-redux": "7.2.6",
    "react-router": "5.2.0",
    "react-router-6": "npm:react-router@6.2.1",
    "react-router-dom": "5.2.0",
    "react-router-dom-6": "npm:react-router-dom@6.2.1",
    "react-scroll": "1.9.0",
    "react-select": "4.3.1",
    "react-transition-group": "4.4.5",
    "reactstrap": "8.10.1",
    "rxjs": "7.8.1",
    "superagent": "8.1.2",
    "swagger-ui": "4.1.3",
    "ua-parser-js": "1.0.39",
    "url": "0.11.3",
    "uuid": "9.0.1"
  },
  "devDependencies": {
    "@axe-core/react": "4.3.2",
    "@babel/core": "7.23.2",
    "@babel/plugin-transform-class-properties": "7.23.3",
    "@babel/plugin-transform-modules-commonjs": "7.23.3",
    "@babel/plugin-transform-object-assign": "7.23.3",
    "@babel/plugin-transform-object-rest-spread": "7.23.3",
    "@babel/plugin-transform-runtime": "7.23.3",
    "@babel/preset-env": "7.13.9",
    "@babel/preset-react": "7.12.13",
    "@datadog/datadog-ci": "2.43.0",
    "@parcel/babel-preset-env": "2.16.4",
    "@parcel/core": "2.16.4",
    "@parcel/optimizer-terser": "2.16.4",
    "@parcel/transformer-inline-string": "2.16.4",
    "@parcel/transformer-less": "2.16.4",
    "@testing-library/react-hooks": "7.0.2",
    "@types/enzyme": "3.10.10",
    "@types/jest": "29.5.3",
    "@welldone-software/why-did-you-render": "4.3.2",
    "@wojtekmaj/enzyme-adapter-react-17": "0.6.2",
    "babel-eslint": "10.1.0",
    "babel-jest": "29.6.1",
    "babel-plugin-istanbul": "6.1.1",
    "babel-plugin-syntax-dynamic-import": "6.18.0",
    "babel-plugin-transform-import-meta": "2.2.1",
    "enzyme": "3.11.0",
    "enzyme-to-json": "3.6.1",
    "jest": "29.6.1",
    "jest-axe": "5.0.1",
    "jest-environment-jsdom": "29.6.1",
    "jest-environment-node": "29.6.1",
    "jest-junit": "10.0.0",
    "less": "3.12.2",
    "mockdate": "2.0.5",
    "parcel": "2.16.4",
    "parcel-reporter-static-files-copy": "1.4.0",
    "process": "0.11.10",
    "punycode": "1.4.1",
    "resize-observer-polyfill": "1.5.1",
    "shallow-with-context": "0.4.1",
    "tailwindcss": "3.4.19",
    "ts-jest": "29.0.3",
    "typescript": "4.5.4"
  },
  "keywords": [],
  "@parcel/transformer-css": {
    "errorRecovery": true
  },
  "packageManager": "pnpm@9.15.4",
  "pnpm": {
    "overrides": {
      "@babel/helper-compilation-targets@7.23.6>browserslist": "4.28.7",
      "@babel/preset-env@7.13.9>@babel/plugin-transform-modules-systemjs": "7.29.4",
      "@babel/preset-env@7.23.8>@babel/plugin-transform-modules-systemjs": "7.29.4",
      "@babel/traverse": "^7.23.2",
      "@datadog/datadog-ci@2.43.0>js-yaml": "3.15.2",
      "@datadog/datadog-ci@2.43.0>simple-git": "4.0.1",
      "@datadog/datadog-ci@2.43.0>ws": "7.5.11",
      "@istanbuljs/load-nyc-config@1.1.0>js-yaml": "3.15.2",
      "@parcel/watcher@2.1.0>micromatch": "4.0.8",
      "@sentry/react@7.52.1>@sentry/browser": "7.119.1",
      "@swagger-api/apidom-reference@0.69.3>minimatch": "7.4.8",
      "@types/request@2.48.12>form-data": "2.5.6",
      "@wbdt-sie/brainiac-web-common@1.4.1>immutable": "3.8.4",
      "axios": "1.20.0",
      "brace-expansion@^1": "1.1.20",
      "brace-expansion@^2": "2.1.6",
      "braces": "3.0.3",
      "core-js-compat@3.30.2>browserslist": "4.28.7",
      "core-js-compat@3.35.0>browserslist": "4.28.7",
      "cross-spawn": "7.0.5",
      "external-editor@3.1.0>tmp": "0.2.7",
      "fast-uri": "3.1.7",
      "fast-xml-parser": "4.5.5",
      "flat-cache@3.0.4>flatted": "3.4.2",
      "form-data": "4.0.6",
      "get-uri@6.0.4>basic-ftp": "6.2.1",
      "google-gax@4.4.1>@grpc/grpc-js": "1.13.6",
      "http-proxy-agent@5.0.0>@tootallnate/once": "2.0.1",
      "js-yaml": "4.3.2",
      "jws": "4.0.1",
      "lodash": "4.18.1",
      "minimatch": "3.1.4",
      "picomatch": "2.3.2",
      "postcss": "8.5.18",
      "prebuild-install@6.1.4>tar-fs": "2.1.4",
      "protobufjs": "7.6.5",
      "qs": "6.14.2",
      "simple-git@4.0.1>@simple-git/argv-parser": "2.0.1",
      "socks@2.8.3>ip-address": "10.3.1",
      "source-map-js@<1.2.2": "1.2.2",
      "superagent@8.1.2>formidable": "2.1.3",
      "swagger-client@3.19.7>cookie": "0.7.0",
      "swagger-ui>dompurify": "2.5.4",
      "update-browserslist-db@1.2.3>browserslist": "4.28.7",
      "ws": "8.21.0"
    }
  },
  "targets": {
    "qa": {
      "context": "browser",
      "sourceMap": {
        "inlineSources": false,
        "inline": false
      }
    },
    "uat": {
      "context": "browser",
      "sourceMap": {
        "inlineSources": false,
        "inline": false
      }
    },
    "prod": {
      "context": "browser",
      "sourceMap": {
        "inlineSources": false,
        "inline": false
      }
    }
  }
}
